import { useQuery } from '@tanstack/react-query';

import {
  useRequest,
  getCollectionListKey as getCollectionKey,
} from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  CollectionData,
  UseCollectionParams,
  CollectionQueryKey,
} from './types';

export const useCollection: QueryFunction<
  CollectionData,
  [UseCollectionParams],
  CollectionQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getCollectionKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/users/collection/${params.collectionId}`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
